<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Kelola</strong> {{ title }} </h1>
            <div> Modul ini digunakan untuk melakukan Kelola Daftar {{ title }} Sekolah Penggerak </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <statistik :value="statistik"></statistik>-->
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          btn-download
          btn-filter
          :btn-add="$allow(`${access}.ganti`)"
          @add="onAdd"
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang_profil"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="fetchData"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Kandididat yang perlu di periksa</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="5">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-home</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 my-3">
                          <div class="black--text subtitle-2">
                            {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                          </div>
                          <div class="caption">
                            <span>
                              <v-icon small left>mdi-label-outline</v-icon>
                              {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                            </span>
                            <br />
                            <span>
                              <v-icon small left>mdi-map-marker</v-icon>
                              {{ $getDeepObj(item, 'instansi.data.nama') || '-' }}
                            </span>
                            <br />
                            <span>
                              <v-icon small left>mdi-city</v-icon>
                              {{ $getDeepObj(item, 'sekolah.data.m_jenjang.data.singkat') || '-' }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Waktu Pengajuan</span>
                          <p class="ma-0">
                            <span>{{ $localDate(item.wkt_ajuan || '', false, true) || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div><span class="caption">Status</span></div>
                          <div v-if="item.gelombang_susul">
                            <div>
                              <v-chip color="purple" dark small>
                                Ganti Peserta
                              </v-chip>
                            </div>
                          </div>
                          <div v-else>
                            <v-chip :color="M_COLOR[item.k_ajuan_diklat_psp] || 'grey'" dark small>
                              {{ $getDeepObj(item, 'm_ajuan_diklat_psp.data.keterangan') || '-' }}
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 my-3">
                          <div><span class="caption">Aksi Selanjutnya</span></div>
                          <v-btn
                            v-if="$allow('psp-peserta-diklat-guru-pkp.update') && +item.k_ajuan_diklat_psp < 2"
                            color="primary"
                            small
                            block
                            @click="onUbahPeserta(item)"
                          >
                            Tambah Peserta
                          </v-btn>
                          <v-btn
                            v-else-if="$allow(`${access}.verval`, item.policies) && +item.k_ajuan_diklat_psp === 2"
                            color="primary"
                            small
                            block
                            @click="onVerval(item)"
                          >
                            PERIKSA
                          </v-btn>
                          <v-btn v-else color="success" outlined dark small block @click="onVerval(item)">
                            LIHAT DETIL
                          </v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <template v-if="allows(item)">
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </template>
                  <template v-else>
                    <div style="min-width: 40px">&nbsp;</div>
                  </template>
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>

    <base-modal-full
      ref="modal"
      :title="formulir['title']"
      :autoClose="formulir['autoClose']"
      :mode="formulir['mode']"
      @close="onClose"
      @save="onSave"
    >
      <component
        ref="formulir"
        is-p4tk
        :is="formulir['form']"
        :config="formulir['config']"
        :peserta-psp="formulir['peserta']"
        :kandidat-psp="formulir['kandidat']"
        :kompetensi="formulir['kompetensi']"
        :masters="Object.assign({}, masters)"
        :id="formulir['id']"
        :detail="formulir['detail']"
        :mode="formulir['mode']"
        :initValue="formulir['init']"
        :type="formulir['type']"
        :is-diklat-smk="formulir['is_diklat_smk']"
      ></component>
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import FormSekolah from '@views/instansi/diklat/formulir/Sekolah';
import FormVerval from './formulir/Verval';
import FormInfo from '../ajuan/formulir/Info';
import FormPeserta from '../ajuan/formulir/Peserta';
import FormPesertaGtk from '@views/gtk/pkp/peserta/ajuan/Formulir';
export default {
  name: 'Index',
  components: { FormSekolah, FormVerval, FormInfo, FormPeserta, FormPesertaGtk },
  mixins: [list],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    access: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      M_COLOR: {
        1: 'grey',
        2: 'blue',
        4: 'success',
        5: 'warning',
      },
      jenis: '',
      formulir: {},
      meta: {},
      masterInstansi: [],
      listLaporan: [
        {
          key: 'download-peserta',
          label: `Daftar Laporan Verval Ajuan Peserta Diklat`,
        },
      ],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
      diklat: (state) => (state.data && state.data.diklat) || {},
      pspConfig: (state) => (state.data && state.data.config) || {},
    }),

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Pilih Provinsi', 'Pilih Kab / Kota'],
        options: [M_PROPINSI, M_KOTA],
        grid: [
          { cols: 12, lg: 6 },
          { cols: 12, lg: 6 },
        ],
        disabled: [],
      };
    },

    mapTimVerval() {
      let temp = {};
      for (const akun of this.listTimVerval) {
        temp[this.$getDeepObj(akun, 'akun.data.akun_id')] = this.$getDeepObj(akun, 'akun.data.nama');
      }
      return temp;
    },

    mGelombang() {
      const result = [];

      for (let i = Number(this.pspConfig['diklat-komite']['gelombang_profil']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },

    formFilter() {
      let master = Object.assign({}, this.masters.ajuan_diklat_psp);
      let jenjangs = Object.assign({}, this.masters.jenjang);

      for (const kJenjang in jenjangs) {
        if (+kJenjang > 6) {
          delete jenjangs[kJenjang];
        }

        if (/paud/.test(this.type) && +kJenjang !== 1) {
          delete jenjangs[kJenjang];
        }

        // if (!/paud/.test(this.type) && +kJenjang === 1) {
        //   delete jenjangs[kJenjang];
        // }
      }

      // delete kandidat
      // delete master[1];
      delete master[3];
      return [
        {
          label: 'Pilih Status Verval',
          row: true,
          default: true,
          type: 'checkbox',
          model: 'k_ajuan_diklat_psp',
          master: this.$mapForMaster(master),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12 },
        },
        {
          label: 'Pilih Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 12 },
        },
        {
          label: 'Pilih Instansi',
          type: 'select',
          model: 'instansi_id',
          master: this.masterInstansi,
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Jenjang',
          type: 'select',
          default: true,
          model: 'k_jenjang',
          master: this.$mapForMaster(jenjangs),
          props: ['multiple', 'chips', 'small-chips'],
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Gelombang PKP',
          type: 'select',
          model: 'gelombang',
          master: [
            { text: 'Gelombang PKP 1', value: 1 },
            { text: 'Gelombang PKP 2', value: 2 },
          ],
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      let instansis = {};
      for (const ins of this.masterInstansi) {
        instansis[ins.value] = ins.text;
      }

      return {
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
        instansi_id: instansis,
        k_ajuan_diklat_psp: this.masters && this.masters['ajuan_diklat_psp'],
        k_jenjang: this.masters && this.masters['jenjang'],
        gelombang: { 1: 'Gelombang PKP 1', 2: 'Gelombang PKP 2' },
      };
    },
  },
  created() {
    this.getInstansi();
    this.getMasters('ajuan_diklat_psp;propinsi;kota;jenjang|value:singkat');
  },
  mounted() {
    this.$set(this.params, 'gelombang_profil', this.$getDeepObj(this, `pspConfig.diklat-komite.gelombang_profil`));
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('diklat', ['fetch', 'kandidat', 'getDetail', 'action', 'instansis', 'downloadList', 'gantiPeserta']),

    fetchData: function() {
      return new Promise((resolve) => {
        let params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const type = this.type;

        // tambah param k_jenjang (wajib)
        if (!(params.k_jenjang || []).length) {
          if (this.$route.name === 'pkp-verval-paud') {
            params.k_jenjang = [1];
          }
          // else {
          //   params.k_jenjang = [2, 3, 4, 5, 6];
          // }
        }

        this.fetch({ params, type }).then(({ data, meta }) => {
          this.data = data || [];
          this.meta = meta || {};
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          // if (!this.filters.gelombang) {
          //   this.params.gelombang = meta?.gelombang || 1;
          //   this.filters.gelombang = meta?.gelombang || 1;
          // }
          resolve(true);
        });
      });
    },

    downloadLaporan(url) {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.downloadList({ params, type: this.type, url: url.dokumen }).then((url) => {
        this.$downloadFile(url);
      });
    },

    allows(data) {
      return (
        this.actions.filter((action) => {
          return this.allow(action, data);
        }).length > 0
      );
    },

    allow(action, data) {
      let allow = false;

      switch (action.event) {
        case 'onBatalGanti':
          allow =
            this.$allow(action.akses, data.policies) &&
            Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) > 2 &&
            this.$getDeepObj(data, 'gelombang_susul');
          break;
        case 'onBatalVerval':
          allow =
            this.$allow(action.akses, data.policies) &&
            Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) > 2 &&
            !this.$getDeepObj(data, 'gelombang_susul');
          break;
        case 'onVerval':
          allow =
            this.$allow(action.akses, data.policies) && Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) === 2;
          break;
        case 'onHapusSekolah':
          allow = this.$allow(action.akses, data.policies) && Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) < 2;
          break;
        case 'onPindahKasek':
          allow =
            this.$allow(action.akses, data.policies) &&
            Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) > 2 &&
            this.$getDeepObj(data, 'gelombang_susul') &&
            !Number(this.$getDeepObj(data, 'is_tujuan_ganti'));
          break;
        case 'onBatalPindahKasek':
          allow =
            this.$allow(action.akses, data.policies) &&
            Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) > 2 &&
            this.$getDeepObj(data, 'gelombang_susul') &&
            Number(this.$getDeepObj(data, 'is_tujuan_ganti')) === 1;
          break;
        case 'onUbahPeserta':
          allow = this.$allow(action.akses) && data.k_ajuan_diklat_psp <= 2; //this.meta.editable && data.k_ajuan_diklat_psp >= 2;
          break;
        case 'onSinkron':
          allow =
            this.$allow(action.akses, data.policies) && Number(this.$getDeepObj(data, 'k_ajuan_diklat_psp')) === 4;
          break;
        default:
          allow = this.$allow(action.akses, data.policies);
          break;
      }
      return allow;
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        let message = '<h3>Apakah Anda yakin ingin keluar dari halaman Verifikasi Berkas Peserta ?</h3>';
        if (this.formulir['form'] === 'FormSekolah') {
          message = '<h3>Apakah Anda yakin ingin keluar dari halaman Ganti Peserta ?</h3>';
        } else if (this.formulir['form'] === 'FormPeserta') {
          message = '<h3>Apakah Anda yakin ingin keluar dari halaman Ubah Peserta ?</h3>';
        }

        const msg = [message, 'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini'].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    async onVerval(item) {
      const kVerval = Number(item.k_ajuan_diklat_psp);
      const mode = this.$allow(`psp-peserta-diklat-guru-pkp.verval`) && kVerval === 2 ? 'form' : 'detail';
      const status = {
        color: this.getColor(kVerval),
        keterangan: this.$getDeepObj(item, 'm_ajuan_diklat_psp.data.keterangan') || '-',
      };

      let init = {};
      // let statistik = this.statistik;

      init = {
        pilihan: '',
        alasan: item.alasan,
      };

      this.$set(this.formulir, 'form', mode === 'form' ? 'FormVerval' : 'FormInfo');
      this.$set(this.formulir, 'title', 'Pemeriksaan Daftar Peserta Diklat Komite');
      this.$set(this.formulir, 'id', item.psp_diklat_sekolah_id);
      // this.$set(this.formulir, 'statistik', statistik);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'type', this.type);

      this.getDetail({ id: this.formulir.id, type: this.type }).then(({ data }) => {
        this.$set(this.formulir, 'mode', mode);
        this.$set(this.formulir, 'autoClose', mode === 'detail');

        this.$refs.modal.open();
        this.$nextTick(() => {
          if (mode === 'form') {
            this.$refs.formulir.reset();
          }

          this.$set(this.formulir, 'init', init);
          this.$set(this.formulir, 'detail', data);
          this.$set(this.formulir.detail, 'status', status);
        });
      });
    },

    onAdd() {
      this.$set(this.formulir, 'masters', this.masters);
      this.$set(this.formulir, 'form', 'FormSekolah');
      this.$set(this.formulir, 'title', 'Ganti Peserta');
      this.$set(this.formulir, 'mode', 'form');
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'init', null);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onUbahPeserta(sekolah) {
      if (sekolah.gelombang_profil > 1) {
        this.onUbahPesertaGel2(sekolah);
        return;
      }

      const { data, meta } = await this.getDetail({
        type: 'diklat-guru',
        id: this.$getDeepObj(sekolah, 'psp_diklat_sekolah_id'),
      });
      const init = {
        detail: data,
        guru: meta?.guru ?? [],
        mapel: meta?.mapel ?? [],
      };

      this.formulir = {};
      this.$set(this.formulir, 'id', this.$getDeepObj(sekolah, 'psp_diklat_sekolah_id'));
      this.$set(this.formulir, 'form', 'FormPeserta');
      this.$set(this.formulir, 'mode', 'form');
      this.$set(this.formulir, 'title', `Ubah Peserta Diklat`);
      this.$set(this.formulir, 'type', 'diklat-guru');
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'meta', meta);
        this.$set(this.formulir, 'init', init);
      });
    },

    async onUbahPesertaGel2(sekolah) {
      const detail = await this.getDetail({
        api: 'dpp-pkp',
        id: this.$getDeepObj(sekolah, 'psp_diklat_sekolah_id'),
      });
      const pspDiklatSekolah = detail.psp_diklat_sekolah || {};
      const kompetensi = detail.kompetensi || {};

      const kandidat = await this.kandidat({
        api: 'dpp-dkp',
        id: this.$getDeepObj(sekolah, 'psp_diklat_sekolah_id'),
      });
      const mapels = kandidat.mapel || [];
      const indexBk = mapels.findIndex((item) => item.kelompok === 'BK');
      const kMapelBk = indexBk > -1 ? mapels[indexBk] && mapels[indexBk]['k_mapel_psp'] : false;

      this.$set(this.formulir, 'autoClose', true);
      this.$set(this.formulir, 'title', 'Pemilihan Guru dan Pengawas PKP');
      this.$set(this.formulir, 'mode', 'form');
      this.$set(this.formulir, 'form', 'FormPesertaGtk');
      this.$set(this.formulir, 'detail', { psp_diklat_sekolah: pspDiklatSekolah || {} });
      this.$set(this.formulir, 'config', mapels);
      this.$set(this.formulir, 'kandidat', kandidat);
      this.$set(this.formulir, 'kompetensi', kompetensi);
      this.$set(this.formulir, 'is_diklat_smk', this.$getDeepObj(pspDiklatSekolah, 'sekolah.k_jenjang') === 5);
      const ptkIdWakasek = this.$getDeepObj(pspDiklatSekolah, 'ptk_id_wakasek') || '';
      this.$set(this.formulir, 'peserta', {
        bk: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) => item.k_mapel_psp === kMapelBk && item.is_cadangan !== 1
        ),
        bkCadang: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) => item.k_mapel_psp === kMapelBk && item.is_cadangan === 1
        ),
        kejuruan: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) => +item.k_mapel_psp === 208 && +item.is_cadangan !== 1
        ),
        kejuruanLain: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) => +item.k_mapel_psp === 210 && +item.is_cadangan !== 1
        ),
        kejuruanCadang: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) => +this.$getDeepObj(item, 'm_mapel_psp.is_kejuruan') === 1 && +item.is_cadangan === 1
        ),
        guru: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) =>
            item.k_mapel_psp !== kMapelBk &&
            +this.$getDeepObj(item, 'm_mapel_psp.is_kejuruan') !== 1 &&
            item.is_cadangan !== 1
        ),
        cadangan: (this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_gurus') || []).filter(
          (item) =>
            item.k_mapel_psp !== kMapelBk &&
            +this.$getDeepObj(item, 'm_mapel_psp.is_kejuruan') !== 1 &&
            item.is_cadangan === 1
        ),
        pengawas: this.$getDeepObj(pspDiklatSekolah, 'psp_diklat_pengawases') || [],
        wakasek: ptkIdWakasek ? [{ ptk_id: ptkIdWakasek || '' }] : [],
      });
      this.$set(this.formulir, 'useSave', true);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.setKandidat(kandidat);
      });
    },

    onSave() {
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      const status = formulir.pilihan;
      const alasan = formulir.alasan;
      const id = formulir.id;
      const params = formulir.params;
      let type = this.type;
      let action = 'verval';

      if (this.formulir.form === 'FormPesertaGtk') {
        this.onSavePesertaGel2(formulir);
        return;
      }

      if (this.formulir.form === 'FormPeserta') {
        if (!formulir.diklat_pengawas.ptk_id) {
          this.$error('Pastikan Anda telah memilih data pengawas');
          this.$refs.modal.loading = false;
          return;
        }

        this.action({ id: this.formulir.id, type, action: 'update-peserta', params: formulir })
          .then(() => {
            this.$success('Data Peserta berhasil di ubah');
            this.$refs.modal.dialog = false;
            this.onReload();
          })
          .catch(() => {
            this.$refs.modal.loading = false;
          });
        return;
      }

      if (this.formulir.form === 'FormSekolah') {
        if (!params.diklat_pengawas && !params.ganti.length && !params.diklat_gurus.length && !params.ganti_kasek) {
          this.$error('Tidak ada peserta ataupun pengawas yang diganti ataupun ditambahkan');
          this.$refs.modal.loading = false;
          return;
        }

        this.gantiPeserta({ id, type, params })
          .then(() => {
            this.$success('Data peserta berhasil disimpan');
            this.$refs.modal.dialog = false;
            this.onReload();
          })
          .catch(() => {
            this.$refs.modal.loading = false;
          });
        return;
      }

      if (status) {
        const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
          status === 4 ? 'menerima' : 'menyatakan perbaikan'
        }</strong> ajuan verval berikut ?</span>`;

        this.$confirm(html, 'Konfirmasi', { tipe: status === 4 ? 'success' : 'warning' }).then(() => {
          this.$refs.modal.loading = true;
          this.action({ id, api: 'dpp-pkp', action, params: { k_ajuan_diklat_psp: status, alasan } })
            .then(() => {
              this.$success('Data ajuan berhasil di ubah');
              this.$refs.modal.dialog = false;
              this.onReload();
            })
            .catch(() => {
              this.$refs.modal.loading = false;
            });
        });
        this.$refs.modal.loading = false;
      } else {
        this.$error('Silakan tentukan hasil verifikasi data sebelum simpan');
        this.$refs.modal.loading = false;
      }
    },

    onSavePesertaGel2(formData) {
      const pspDiklatSekolah = this.$getDeepObj(this.formulir.detail, 'psp_diklat_sekolah') || {};
      const id = pspDiklatSekolah.psp_diklat_sekolah_id || '';
      const isDiklatSmk = this.$getDeepObj(pspDiklatSekolah, 'sekolah.k_jenjang') === 5;
      const indexBk = this.formulir.config.findIndex((item) => item.kelompok === 'BK');
      const indexUmum = this.formulir.config.findIndex((item) => item.kelompok === null);
      const indexKejuruan = this.formulir.config.findIndex((item) => +item.k_mapel_psp === 208);
      const indexKejuruanLain = this.formulir.config.findIndex((item) => +item.k_mapel_psp === 210);

      let ptk_id_wakasek = '';
      let gurus = [];
      let pengawases = [];
      for (const key in formData) {
        if (key === 'pengawas') {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
              };
            });
          pengawases.push(...data);
        } else if (key === 'wakasek') {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
              };
            });
          ptk_id_wakasek = (data[0] && data[0]['ptk_id']) || '';
        } else if (indexBk > -1 && ['bk', 'bkCadang'].includes(key)) {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
                k_mapel_psp: this.formulir.config[indexBk]['k_mapel_psp'],
                is_cadangan: Number(key === 'bkCadang'),
              };
            });

          gurus.push(...data);
        } else if (indexKejuruan > -1 && ['kejuruan', 'kejuruanCadang'].includes(key)) {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
                k_mapel_psp: this.formulir.config[indexKejuruan]['k_mapel_psp'],
                is_cadangan: Number(key === 'kejuruanCadang'),
              };
            });

          gurus.push(...data);
        } else if (indexKejuruanLain > -1 && ['kejuruanLain'].includes(key)) {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
                k_mapel_psp: this.formulir.config[indexKejuruanLain]['k_mapel_psp'],
                is_cadangan: Number(key === 'kejuruanCadang'),
              };
            });

          gurus.push(...data);
        } else {
          const data = formData[key]
            .filter((n) => n)
            .map((item) => {
              return {
                ptk_id: item,
                k_mapel_psp: this.formulir.config[indexUmum]['k_mapel_psp'],
                is_cadangan: Number(key === 'cadangan'),
              };
            });
          gurus.push(...data);
        }
      }

      // validate
      // if (!gurus.length) {
      //   this.$error(`Silakan memilih Peserta Guru dan Pengawas PKP!`);
      //   this.$refs.modal.loading = false;
      //   return;
      // }

      let params = { gurus, pengawases };
      if (isDiklatSmk && ptk_id_wakasek) {
        params = { gurus, pengawases, ptk_id_wakasek };
      }

      this.action({ id, api: 'dpp-pkp', action: 'update', params })
        .then(() => {
          this.$refs.modal.loading = false;
          this.$success('Peserta PKP berhasil disimpan');
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onBatalVerval(data) {
      const api = 'dpp-pkp';
      const action = 'batal-verval';

      this.$confirm(`Anda yakin ingin membatalkan VerVal Ajuan di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, api, action }).then(() => {
          this.$success(`Batal Verval Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onBatalGanti(data) {
      const type = this.type;
      const action = 'batal-ganti';

      this.$confirm(`Anda yakin ingin membatalkan peserta untuk sekolah di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, type, action }).then(() => {
          this.$success(`Batal Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onHapusSekolah(data) {
      const type = this.type;
      const action = 'delete';

      this.$confirm(`Anda yakin ingin menghapus data Sekolah Peserta di atas?`, `Hapus Sekolah Peserta`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, type, action }).then(() => {
          this.$success(`Hapus Sekolah Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onPindahKasek(data) {
      const type = this.type;
      const action = 'pindah-kasek';

      this.$confirm(
        `Anda yakin ingin memindahkan Kepala Sekolah di atas ke <strong>Kelompok B</strong>?`,
        `Pindahkan Kelompok Kepala Sekolah`,
        {
          tipe: 'error',
          data: this.confirmHtml(data),
        }
      ).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, type, action }).then(() => {
          this.$success(`Kepala Sekolah berhasil dipindah ke Kelompok B`);
          this.onReload();
        });
      });
    },

    onBatalPindahKasek(data) {
      const type = this.type;
      const action = 'batal-pindah-kasek';

      this.$confirm(
        `Anda yakin ingin membatalkan pindah Kepala Sekolah di atas ke <strong>Kelompok B</strong>?`,
        `Batalkan Pindah Kelompok Kepala Sekolah`,
        {
          tipe: 'error',
          data: this.confirmHtml(data),
        }
      ).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, type, action }).then(() => {
          this.$success(`Kepala Sekolah berhasil dibatalkan pindah`);
          this.onReload();
        });
      });
    },

    onSinkron(data) {
      const type = this.type;
      const action = 'sinkronisasi';

      this.$confirm(
        `Apakah Anda ingin sinkronisasi ulang data Peserta Diklat untuk Sekolah di atas ke SIM Diklat?`,
        `Sinkron ulang ke SIM Diklat`,
        {
          tipe: 'info',
          data: this.confirmHtml(data),
        }
      ).then(() => {
        this.action({ id: data.psp_diklat_sekolah_id, type, action })
          .then(() => {
            this.$success(`Berhasil disinkron ulang`);
            this.onReload();
          })
          .catch((error) => {
            if (error === 'Too Many Attempts.') {
              this.$error(`Data sedang dalam proses sinkronisasi <br>Silakan tunggu dalam 5 menit`);
            }
          });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-home',
          iconSize: 40,
          iconColor: 'secondary',
          title: this.$getDeepObj(data, 'sekolah.data.nama') || '',
        },
      ];
    },

    getInstansi() {
      this.instansis({ type: this.type }).then(({ data }) => {
        this.masterInstansi = data.map((item) => {
          return { text: item.nama, value: item.instansi_id };
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
